import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import * as glamor from 'glamor';
import glamorous from 'glamorous';
import SearchInput, {MODE_FLOATING} from '../../../../shared/library/search/search-input';
import {ASH} from '../../../../shared/style/colors';
import ToolSearchProvider from '../../../../shared/library/search/providers/tool';

const PLACEHOLDER_TEXT = 'Search for tools...';

const magic = glamor.css.keyframes({
  '0%': {backgroundPosition: `0 0`},
  '100%': {backgroundPosition: `100em 0`}
});

const Loader = glamorous.div(
  {
    borderRadius: 2,
    // background: `linear-gradient(to right, #f1f1f1 0%, #fbfbfb 50%, #f1f1f1 100%)`,
    backgroundSize: '200% 100%'
    // animation: `20s ${magic} 0s linear infinite`
  },
  ({w = 'auto', h = 'auto', animate}) => ({
    width: w,
    height: h,
    animation: animate ? `20s ${magic} 0s linear infinite` : 'none',
    background: animate
      ? `linear-gradient(to right, #f1f1f1 0%, #fbfbfb 50%, #f1f1f1 100%)`
      : `#f9f9f9`
  })
);

const Logo = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flexGrow: 1,
  '>:first-child': {
    marginBottom: 5
  },
  marginBottom: 34
});

const Actions = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: 'auto',
  flexWrap: 'wrap',
  marginBottom: 32
});

const Stats = glamorous.div({
  display: 'flex',
  width: '80%',
  justifyContent: 'space-between',
  borderTop: `1px solid #f9f9f9`,
  paddingTop: 25,
  marginTop: -9
});

const Stat = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '>:first-child': {
    marginBottom: 10
  },
  paddingBottom: 3
});

const InputWrapper = glamorous.div({
  width: 'calc(100% - 28px)',
  marginBottom: 17,
  marginTop: -16
});

const Minimal = glamorous.div({
  border: `1px solid ${ASH}`,
  borderRadius: 2,
  display: 'flex',
  padding: 7,
  width: '100%',
  boxSizing: 'border-box'
});

const ToolCardLoader = ({animate, onChange, minimal, focus, otherToolSlugs = []}) => {
  const filterOtherTools = tool => !otherToolSlugs.includes(tool.slug);
  if (onChange && minimal) {
    return (
      <ToolSearchProvider>
        <SearchInput
          placeholder={PLACEHOLDER_TEXT}
          onChange={onChange}
          mode={MODE_FLOATING}
          focus={focus}
          filterResults={filterOtherTools}
        />
      </ToolSearchProvider>
    );
  }
  if (minimal) {
    return (
      <Minimal>
        <Loader w={38} h={38} style={{marginRight: 10}} animate={animate} />
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
          <Loader w={52} h={12.6} style={{marginBottom: 6.4}} animate={animate} />
          <Loader w={72} h={9} animate={animate} />
        </div>
      </Minimal>
    );
  }
  return (
    <Fragment>
      <Logo>
        <Loader w={84} h={84} style={{borderRadius: 4}} animate={animate} />
        {!onChange && <Loader w={48} h={7.6} animate={animate} />}
      </Logo>
      {onChange && (
        <ToolSearchProvider>
          <InputWrapper>
            <SearchInput
              placeholder={PLACEHOLDER_TEXT}
              onChange={onChange}
              focus={focus}
              filterResults={filterOtherTools}
            />
          </InputWrapper>
        </ToolSearchProvider>
      )}
      <Actions>
        {!onChange && <Loader w={'100%'} h={34} style={{marginBottom: 13}} animate={animate} />}
        <Loader w={102} h={25} style={{marginRight: 13}} animate={animate} />
        <Loader w={102} h={25} animate={animate} />
      </Actions>
      <Stats>
        <Stat>
          <Loader w={65} h={9.6} animate={animate} />
          <Loader w={52} h={14.6} animate={animate} />
        </Stat>
        <Stat>
          <Loader w={65} h={9.6} animate={animate} />
          <Loader w={52} h={14.6} animate={animate} />
        </Stat>
        <Stat>
          <Loader w={65} h={9.6} animate={animate} />
          <Loader w={52} h={14.6} animate={animate} />
        </Stat>
      </Stats>
    </Fragment>
  );
};

ToolCardLoader.propTypes = {
  animate: PropTypes.bool,
  onChange: PropTypes.func,
  minimal: PropTypes.bool,
  focus: PropTypes.bool,
  otherToolSlugs: PropTypes.array
};

export default ToolCardLoader;
